import { ACCOUNT_TOTALS_PATH } from 'core/cuenta/routes';
import { CardsTotals } from 'core/tarjeta/models/CardsTotals';
import { useNavigate } from 'react-router-dom';
import { LinkButton } from 'shared/components';
import { Table } from 'shared/table';
import { formatCurrency, formatParams } from 'shared/utils';

export const CardsTotalsTable = (props: {
  periodo: any;
  tableContent: CardsTotals[];
}) => {
  const navigate = useNavigate();
  const clickCardNumberHandler = (total: CardsTotals) => {
    navigate(
      {
        pathname: ACCOUNT_TOTALS_PATH,
        search: formatParams(props.periodo),
      },
      {
        state: {
          cuenta: total.numeroCuenta,
          fromAccountCardTotals: true,
        },
      },
    );
  };

  return (
    <Table
      thead={
        <>
          {props.periodo !== null || (
            <tr>
              <td colSpan={3} align="center"></td>
              <td colSpan={8} align="center">
                Saldos al día de ayer
              </td>
              <td colSpan={2} align="center">
                Saldos al día de hoy
              </td>
            </tr>
          )}
          <tr>
            <td align="center" rowSpan={2}>
              Tarjeta
            </td>
            <td align="center" rowSpan={2}>
              Denominación
            </td>
            <td align="center" rowSpan={2}>
              Cuenta
            </td>
            <td align="center" rowSpan={2}>
              Saldo Anterior
            </td>
            <td align="center" colSpan={2}>
              Transferencias
            </td>
            <td align="center" rowSpan={2}>
              Acredit.
            </td>
            <td align="center" rowSpan={2}>
              Otros
            </td>
            <td align="center" rowSpan={2}>
              Extracciones
            </td>
            <td align="center" rowSpan={2}>
              Consumos
            </td>
            <td align="center" rowSpan={2}>
              Saldo Actual
            </td>
            {props.periodo !== null || (
              <td align="center" rowSpan={2}>
                Disponible
              </td>
            )}
          </tr>
          <tr>
            <td align="center">Crédito</td>
            <td align="center">Débito</td>
          </tr>
        </>
      }
      tbody={
        <>
          {props.tableContent.map((item, index) => (
            <tr key={'total' + index} data-testid={'card-row-' + index}>
              <td className="align-right">
                <LinkButton onClick={() => clickCardNumberHandler(item)}>
                  {item.numeroTarjeta}
                </LinkButton>
              </td>
              <td className="align-left">{item.denominacionTarjeta}</td>
              <td className="align-left">{item.numeroCuenta}</td>
              <td className="align-right">{formatCurrency(item.saldoInicial)}</td>
              <td className="align-right">{formatCurrency(item.transferenciaCredito)}</td>
              <td className="align-right">{formatCurrency(item.transferenciaDebito)}</td>
              <td className="align-right">{formatCurrency(item.acreditaciones)}</td>
              <td className="align-right">{formatCurrency(item.otros)}</td>
              <td className="align-right">{formatCurrency(item.adelantos)}</td>
              <td className="align-right">{formatCurrency(item.consumos)}</td>
              <td className="align-right">{formatCurrency(item.saldoActual)}</td>
              {props.periodo !== null || (
                <td className="align-right">{formatCurrency(item.saldoDisponible)}</td>
              )}
            </tr>
          ))}
        </>
      }
    />
  );
};
